import { createAction } from 'redux-actions-helpers'
import { ModuleScreenType } from './types'
import { ModuleType, ProgressType } from '../CoursePage/types'
import { NewAchievementsItemType } from '../SignInPage/types'

export const fetchModuleScreen = createAction(
  '@@module-screen/FETCH_MODULE_SCREEN',
  (id: string, mid: string, sid: string): any => ({
    id,
    mid,
    sid,
  })
)

export const fetchModuleScreenSuccess = createAction(
  '@@module-screen/FETCH_MODULE_SCREEN_SUCCESS',
  (result: ModuleScreenType): any => ({ result })
)

export const fetchModuleScreenFailure = createAction(
  '@@module-screen/FETCH_MODULE_SCREEN_FAILURE',
  (error: string): any => ({ error })
)

export const fetchModule = createAction(
  '@@module-screen/FETCH_MODULE',
  (id: string, mid: string): any => ({
    id,
    mid,
  })
)

export const fetchModuleSuccess = createAction(
  '@@module-screen/FETCH_MODULE_SUCCESS',
  (result: ModuleType): any => ({ result })
)

export const fetchModuleFailure = createAction(
  '@@module-screen/FETCH_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchModulesList = createAction(
  '@@module-screen/FETCH_MODULES_LIST',
  (id: string): any => ({
    id,
  })
)

export const fetchModulesListSuccess = createAction(
  '@@module-screen/FETCH_MODULES_LIST_SUCCESS',
  (result: ModuleType[]): any => ({ result })
)

export const fetchModulesListFailure = createAction(
  '@@module-screen/FETCH_MODULES_LIST_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCourseUserState = createAction(
  '@@module-screen/FETCH_COURSE_USER_STATE',
  (id: string): any => ({ id })
)

export const fetchCourseUserStateSuccess = createAction(
  '@@module-screen/FETCH_COURSE_USER_STATE_SUCCESS',
  (result: ProgressType): any => ({ result })
)

export const fetchCourseUserStateFailure = createAction(
  '@@module-screen/FETCH_COURSE_USER_STATE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchAchievements = createAction(
  '@@module-screen/FETCH_ACHIEVEMENTS',
  (period: string): any => ({ period })
)

export const fetchAchievementsSuccess = createAction(
  '@@module-screen/FETCH_ACHIEVEMENTS_SUCCESS',
  (result: NewAchievementsItemType[]): any => ({ result })
)

export const fetchAchievementsFailure = createAction(
  '@@module-screen/FETCH_ACHIEVEMENTS_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@module-screen/DESTROY')
